<mat-card class="rubric-card" [ngClass]="competenceClass">
    <mat-card-content>
        <div class="card-header">
            {{ rubricQualitySpec.qualityLevelLabel }}
        </div>
        <p class="card-content" [innerHTML]="rubricQualitySpec.criteria"></p>
    </mat-card-content>
</mat-card>
